export const selectedFloorSelector = ({ floor: { selectedFloor: value } }) => value;
export const floorRoomsSelector = ({ floor: { rooms: value } }) => value;
export const floorWithRoomsSelector = ({ floor: { floors: value } }) => value;
export const floorRoomsWithPhotosSelector = ({ floor: { floorRoomsWithPhotos: value } }) => value;
